module.exports = __webpack_public_path__ + "img/SL.cba4bce7.svg";